// extracted by mini-css-extract-plugin
export default {"Overlay":"Loader_Overlay__+SUnO"};